export default class PromotionUserController {
  constructor(resource) {
    this._resource = resource;
  }

  async getReservationsByPromotionUser(promotionUserId) {
    return this._resource(`promotion_user/report/${promotionUserId}`)
      .get()
      .then(result => result)
      .catch(error => {
        throw error;
      });
  }

  async getById(promotionUserId) {
    return this._resource(`promotion_user/${promotionUserId}`)
      .get()
      .then(result => result)
      .catch(error => {
        console.log(error);
        throw error;
      });
  }

  async getPromotionsUserByPromotionIdAndUserId(promotionId, userId) {
    try {
      let response = await this._resource(
        'promotion_user/get-all/promotion_and_user_id',
        {
          promotionId,
          userId,
        }
      ).get();
      return response.body;
    } catch (e) {
      throw e;
    }
  }

  async getRecurrentReport() {
    return this._resource(`promotion_user/report`)
      .get()
      .then(result => result)
      .catch(error => {
        throw error;
      });
  }

  async getAllRecurrents() {
    return this._resource(`promotion_user/recurrents`)
      .get()
      .then(result => result)
      .catch(error => {
        throw error;
      });
  }

  async getWalletHoursReport() {
    return this._resource(`promotion_user/wallet_hours_report`)
      .get()
      .then(result => result)
      .catch(error => {
        throw error;
      });
  }

  async cancelRecurrence(
    recurrent_payment_id,
    promotionUserId,
    expiration_date
  ) {
    return this._resource(`promotion_user/cancel_recurrence`)
      .update({ recurrent_payment_id, promotionUserId, expiration_date })
      .then(result => result)
      .catch(error => {
        throw error;
      });
  }

  async cancelWalletHours(transaction_id, client_id) {
    return this._resource(`promotionUser/cancelWalletHours`)
      .update({ transaction_id, client_id })
      .then(result => result)
      .catch(error => {
        throw error;
      });
  }

  async getHours() {
    return this._resource(`promotion_user/time_spent_using_promotion`)
      .get()
      .then(res => res)
      .catch(e => {
        throw e;
      });
  }

  async getRecurrentTimeLeft(user_id) {
    return this._resource(`promotion_user/time_spent_using_promotion/by_adm`)
      .get({ user_id: user_id })
      .then(
        res => {
          return res.body;
        },
        err => {
          throw new Error(err);
        }
      );
  }

  async getLastRecurrentPromotionActivationByUserId(userId) {
    const res = await this._resource(
      `promotion-user/last-recurrent-by-user/${userId}`
    ).get();

    return res.body;
  }

  async getLastRecurrentPromotionByUserId(userId) {
    const res = await this._resource(
      `promotion-user/last-recurrent-pattern-by-user/${userId}`
    ).get();

    return res.body;
  }
}
